import React from "react";
import { oneOf } from "prop-types";

const GenderIcon = ({ type }) => {
  if (type === "male") {
    return (
      <svg width="18.75" height="50" viewBox="0 0 18.75 50" xmlns="http://www.w3.org/2000/svg">
        <defs />
        <path
          d="M96 231a6.25 6.25 0 1 1-6.25 6.25A6.25 6.25 0 0 1 96 231m4.687 14.063h-1.109a8.588 8.588 0 0 1-7.156 0h-1.109a4.687 4.687 0 0 0-4.688 4.687v13.281a2.343 2.343 0 0 0 2.344 2.344h1.562v13.281A2.344 2.344 0 0 0 92.875 281h6.25a2.344 2.344 0 0 0 2.344-2.344v-13.281h1.562a2.343 2.343 0 0 0 2.344-2.344V249.75a4.687 4.687 0 0 0-4.688-4.687z"
          fill="#f7f7f7"
          transform="translate(-86.625 -231)"
        />
      </svg>
    );
  } else if (type === "female") {
    return (
      <svg width="23.439" height="50" viewBox="0 0 23.439 50" xmlns="http://www.w3.org/2000/svg">
        <defs />
        <path
          d="M128 231a6.25 6.25 0 1 1-6.25 6.25A6.25 6.25 0 0 1 128 231m11.649 34.588l-4.687-18.75a2.344 2.344 0 0 0-2.274-1.775h-1.11a8.588 8.588 0 0 1-7.156 0h-1.109a2.343 2.343 0 0 0-2.274 1.775l-4.687 18.75a2.344 2.344 0 0 0 2.273 2.912h5.469v10.156a2.343 2.343 0 0 0 2.344 2.344h3.125a2.344 2.344 0 0 0 2.344-2.344V268.5h5.468a2.345 2.345 0 0 0 2.274-2.912z"
          fill="#999"
          transform="translate(-116.281 -231)"
        />
      </svg>
    );
  }

  return null;
};

GenderIcon.propTypes = {
  type: oneOf(["male", "female"])
};

export default GenderIcon;
